import { createFileRoute } from '@tanstack/react-router'
import { requirePortalSession } from '@/portal/portal-guard'

export const Route = createFileRoute('/portal')({
  beforeLoad: () => requirePortalSession(),
})
